import Accesstime from '@material-ui/icons/AccessTime';
import React, { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

interface Styles {
  root?: string;
  icon?: string;
}

interface ShiftHourRangeProps {
  minWeeklyHours?: number;
  maxWeeklyHours?: number;
  styles?: Styles;
}
type HoursTextProps = Pick<
  ShiftHourRangeProps,
  'maxWeeklyHours' | 'minWeeklyHours'
>;

function HoursText({ minWeeklyHours, maxWeeklyHours }: HoursTextProps) {
  if (minWeeklyHours === maxWeeklyHours) {
    return (
      <FormattedMessage
        defaultMessage="{minWeeklyHours} hours weekly"
        description="The applicant will be expected to work this many hours per week"
        values={{ minWeeklyHours }}
      />
    );
  }
  if (minWeeklyHours && !maxWeeklyHours) {
    return (
      <FormattedMessage
        defaultMessage="At least {minWeeklyHours} hours weekly"
        description="The applicant will be expected to work at least this many hours per week"
        values={{ minWeeklyHours }}
      />
    );
  }
  if (!minWeeklyHours && maxWeeklyHours) {
    return (
      <FormattedMessage
        defaultMessage="Up to {maxWeeklyHours} hours weekly"
        description="The applicant will be expected to work up to this many hours per week"
        values={{ maxWeeklyHours }}
      />
    );
  }
  if (minWeeklyHours && maxWeeklyHours) {
    return (
      <FormattedMessage
        defaultMessage="{minWeeklyHours} - {maxWeeklyHours} hours weekly"
        description="The applicant will be expected to work between this many hours per week"
        values={{ minWeeklyHours, maxWeeklyHours }}
      />
    );
  }
  return null;
}
export const ShiftHourRange: VFC<ShiftHourRangeProps> = ({
  minWeeklyHours,
  maxWeeklyHours,
  styles,
}) => {
  if (minWeeklyHours || maxWeeklyHours) {
    return (
      <div className={styles?.root}>
        <Accesstime className={styles?.icon} />
        <HoursText
          minWeeklyHours={minWeeklyHours}
          maxWeeklyHours={maxWeeklyHours}
        />
      </div>
    );
  }
  return null;
};
